






























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import VAutocomplete from "vuetify/lib/components/VAutocomplete";
import VSelect from "vuetify/lib/components/VSelect";
@Component({ inheritAttrs: false, components: { VAutocomplete, VSelect } })
export default class ppdwAutocomplete extends Vue {
    /** Лейбл над полем ввода, если пустая строка, то он не будет занимать место */
    @Prop({ default: "" }) label: string;
    /** Для лейбла */
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: "v-autocomplete" }) component:
        | "v-autocomplete"
        | "v-select";
    @Prop({type: Boolean, default: true }) offsetY: boolean;
    @Prop({ default: () => [] }) rules: Function[];
    @Prop() value: any;
    @Prop(Boolean) top: boolean;
    model: string = "";
    @Watch("value") setModel() {
        this.checkSuccess(this.value, this.rules);
        this.model = this.value;
    }
    async mounted() {
        if (this.value) {
            this.setModel();
            this.checkSuccess(this.value, this.rules);
        }
    }
    handleInput(val) {
        this.checkSuccess(val, this.rules);
        //this.$emit("input", val);
    }
    @Prop({ default: true }) successable: boolean;
    success: boolean = false;
    checkSuccess(value, rules) {
        if (!rules) {
            this.success = true;
            return;
        }
        let state = false;
        for (let rule of rules) {
            if (typeof rule(value) === "string") {
                state = false;
                break;
            } else state = true;
        }
        this.success = state;
    }
}
